/** Dial arc: 270 degree sweep, gap centered at the bottom. */
export const DIAL_START_ANGLE = 135;
export const DIAL_SWEEP = 270;

export function clamp(v: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, v));
}

/** Value in [min, max] to ratio in [0, 1], clamped. */
export function valueToRatio(value: number, min: number, max: number): number {
  if (max === min) return 0;
  return clamp((value - min) / (max - min), 0, 1);
}

/** Ratio in [0, 1] to a value in [min, max], rounded to the nearest step. */
export function ratioToValue(ratio: number, min: number, max: number, step = 0.5): number {
  const raw = min + clamp(ratio, 0, 1) * (max - min);
  if (step <= 0) return raw;
  return Math.round(raw / step) * step;
}

/** Screen-space angle in degrees: 0 = right of center, clockwise positive. */
export function pointToAngle(cx: number, cy: number, x: number, y: number): number {
  const deg = (Math.atan2(y - cy, x - cx) * 180) / Math.PI;
  return (deg + 360) % 360;
}

/**
 * Angle to arc ratio. Angles inside the bottom gap snap to the nearest
 * end so a finger sliding past the end does not wrap around.
 */
export function angleToRatio(angleDeg: number): number {
  const relative = (angleDeg - DIAL_START_ANGLE + 360) % 360;
  if (relative <= DIAL_SWEEP) return relative / DIAL_SWEEP;
  // In the gap (270..360): closer to which end? Exactly mid-gap (315 deg)
  // snaps to 0 (start side) because the comparison is strict `<`.
  return relative - DIAL_SWEEP < (360 - DIAL_SWEEP) / 2 ? 1 : 0;
}
